import React from 'react';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

const Projects = () => {
  const projects = [
    {
      title: 'EventsCalendarZone',
      description: 'Full Stack Event Management Application with user authentication, event CRUD operations, calendar view, and reminders. Built with MERN stack.',
      tech: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'Bootstrap'],
      features: ['User Authentication', 'Event Management', 'Calendar View', 'Reminders', 'Responsive Design'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p2.png'
    },
    {
      title: 'NewAIWorld',
      description: 'AI-Integrated Web Application leveraging AI APIs for intelligent user interactions. Features AI-powered content generation and real-time responses.',
      tech: ['React.js', 'Node.js', 'Express.js', 'MongoDB', 'AI APIs'],
      features: ['AI Integration', 'Real-time Responses', 'User Dashboard', 'Content Generation'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p1.png'
    },
    {
      title: 'E-Commerce Product Catalog',
      description: 'Product listing platform with shopping cart, filter, and search functionality. Integrated with MongoDB for product data management.',
      tech: ['React.js', 'Node.js', 'MongoDB', 'Bootstrap'],
      features: ['Product Listing', 'Shopping Cart', 'Search & Filter', 'Responsive UI'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p3.png'
    },
    {
      title: 'Task Management System',
      description: 'To-do application with CRUD operations and user authentication. User-specific task lists with full MERN stack implementation.',
      tech: ['React.js', 'Node.js', 'Express.js', 'MongoDB'],
      features: ['CRUD Operations', 'User Authentication', 'Task Lists', 'Priority Management'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p5.png'
    },
    {
      title: 'Weather Application',
      description: 'Real-time weather app with API integration. Responsive design with dynamic weather data display for any location.',
      tech: ['React.js', 'Weather API', 'Bootstrap', 'JavaScript'],
      features: ['Real-time Data', 'Location Search', 'Responsive Design', 'API Integration'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p6.png'
    },
    {
      title: 'Personal Portfolio',
      description: 'Professional portfolio website showcasing skills, projects, and experience. Built with modern React and responsive design.',
      tech: ['React.js', 'HTML5', 'CSS3', 'Bootstrap'],
      features: ['Responsive Design', 'Contact Form', 'Project Showcase', 'Modern UI/UX'],
      github: 'https://github.com/SuboKumar2356',
      demo: '#',
      image: '/assets/images/p4.png'
    }
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=Space+Mono:wght@400;700&display=swap');

        :root {
          --accent:  #00f5d4;
          --accent2: #7b61ff;
          --accent3: #ff4ecd;
          --bg:      #07090f;
          --text:    #e8eaf6;
          --muted:   rgba(232,234,246,0.45);
          --border:  rgba(0,245,212,0.13);
          --card-bg: rgba(255,255,255,0.03);
        }

        .pr-section {
          position: relative;
          padding: 6rem 2rem;
          background: var(--bg);
          font-family: 'Syne', sans-serif;
          overflow: hidden;
        }

        .pr-section::before {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 0;
          background:
            radial-gradient(ellipse 50% 60% at 80% 20%, rgba(123,97,255,0.1) 0%, transparent 70%),
            radial-gradient(ellipse 40% 50% at 10% 80%, rgba(0,245,212,0.07) 0%, transparent 70%);
          pointer-events: none;
        }

        .pr-section::after {
          content: '';
          position: absolute;
          inset: 0;
          z-index: 0;
          background: repeating-linear-gradient(
            0deg,
            transparent, transparent 2px,
            rgba(0,245,212,0.015) 2px, rgba(0,245,212,0.015) 4px
          );
          pointer-events: none;
        }

        .pr-inner {
          position: relative;
          z-index: 1;
          max-width: 1400px;
          margin: 0 auto;
        }

        .pr-heading {
          text-align: center;
          margin-bottom: 4rem;
          opacity: 0;
          animation: prFadeUp 0.6s ease 0.1s forwards;
        }

        .pr-tag {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'Space Mono', monospace;
          font-size: 0.68rem;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          color: var(--accent);
          margin-bottom: 1rem;
        }

        .pr-tag::before, .pr-tag::after {
          content: '';
          display: inline-block;
          width: 20px;
          height: 1.5px;
          background: var(--accent);
          box-shadow: 0 0 8px var(--accent);
        }

        .pr-main-title {
          font-size: clamp(1.8rem, 4vw, 2.8rem);
          font-weight: 800;
          letter-spacing: -0.03em;
          color: #fff;
        }

        .pr-main-title .pr-accent {
          background: linear-gradient(90deg, var(--accent) 0%, var(--accent2) 60%, var(--accent3) 100%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          background-size: 200% auto;
          animation: prGrad 4s linear infinite;
        }

        .pr-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
          gap: 2rem;
        }

        .pr-card {
          background: var(--card-bg);
          border: 1px solid var(--border);
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          backdrop-filter: blur(2px);
          opacity: 0;
          transform: translateY(20px);
          animation: prCardReveal 0.5s ease forwards;
          display: flex;
          flex-direction: column;
        }

        .pr-card:nth-child(1) { animation-delay: 0.05s; }
        .pr-card:nth-child(2) { animation-delay: 0.1s; }
        .pr-card:nth-child(3) { animation-delay: 0.15s; }
        .pr-card:nth-child(4) { animation-delay: 0.2s; }
        .pr-card:nth-child(5) { animation-delay: 0.25s; }
        .pr-card:nth-child(6) { animation-delay: 0.3s; }

        .pr-card:hover {
          border-color: rgba(0,245,212,0.35);
          background: rgba(0,245,212,0.04);
          transform: translateY(-8px);
          box-shadow: 0 20px 40px -12px rgba(0,0,0,0.6);
        }

        .pr-card-img-wrapper {
          position: relative;
          overflow: hidden;
          height: 220px;
          background: linear-gradient(135deg, rgba(0,245,212,0.05), rgba(123,97,255,0.05));
        }

        .pr-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .pr-card:hover .pr-card-img {
          transform: scale(1.05);
        }

        .pr-card-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0,245,212,0.1), rgba(123,97,255,0.1));
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .pr-card:hover .pr-card-overlay {
          opacity: 1;
        }

        .pr-card-body {
          padding: 1.5rem;
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .pr-card-title {
          font-size: 1.35rem;
          font-weight: 700;
          color: #fff;
          margin-bottom: 0.75rem;
          letter-spacing: -0.02em;
          background: linear-gradient(135deg, #fff, #b0b8ff);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }

        .pr-card-desc {
          font-size: 0.85rem;
          color: var(--muted);
          line-height: 1.6;
          margin-bottom: 1rem;
        }

        .pr-section-title {
          font-family: 'Space Mono', monospace;
          font-size: 0.7rem;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: var(--accent);
          margin-bottom: 0.75rem;
          font-weight: 600;
        }

        .pr-tech-stack {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1rem;
        }

        .pr-tech-badge {
          background: rgba(0,245,212,0.1);
          border: 1px solid rgba(0,245,212,0.2);
          border-radius: 40px;
          padding: 0.25rem 0.8rem;
          font-family: 'Space Mono', monospace;
          font-size: 0.6rem;
          font-weight: 500;
          color: var(--accent);
          letter-spacing: 0.02em;
          transition: all 0.2s;
        }

        .pr-tech-badge:hover {
          background: rgba(0,245,212,0.2);
          border-color: var(--accent);
          transform: translateY(-1px);
        }

        .pr-features-list {
          list-style: none;
          padding: 0;
          margin: 0 0 1rem 0;
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .pr-feature-item {
          font-size: 0.7rem;
          color: var(--muted);
          display: flex;
          align-items: center;
          gap: 0.3rem;
          font-family: 'Space Mono', monospace;
        }

        .pr-feature-item::before {
          content: '▹';
          color: var(--accent2);
          font-size: 0.6rem;
        }

        .pr-card-actions {
          display: flex;
          gap: 0.8rem;
          margin-top: auto;
          padding-top: 1rem;
        }

        .pr-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          border-radius: 40px;
          font-family: 'Space Mono', monospace;
          font-size: 0.7rem;
          font-weight: 600;
          letter-spacing: 0.05em;
          text-decoration: none;
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .pr-btn-github {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.1);
          color: var(--text);
        }

        .pr-btn-github:hover {
          border-color: var(--accent);
          background: rgba(0,245,212,0.1);
          transform: translateY(-2px);
          color: var(--accent);
        }

        .pr-btn-demo {
          background: linear-gradient(135deg, var(--accent), var(--accent2));
          border: none;
          color: var(--bg);
        }

        .pr-btn-demo:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0,245,212,0.3);
        }

        @keyframes prFadeUp {
          from { opacity: 0; transform: translateY(24px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        @keyframes prGrad {
          0%   { background-position: 0% center; }
          100% { background-position: 200% center; }
        }

        @keyframes prCardReveal {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 900px) {
          .pr-section { padding: 4rem 1.5rem; }
          .pr-grid { grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 1.5rem; }
        }

        @media (max-width: 480px) {
          .pr-grid { grid-template-columns: 1fr; }
          .pr-card-title { font-size: 1.2rem; }
          .pr-card-body { padding: 1.2rem; }
        }
      `}</style>

      <section id="projects" className="pr-section">
        <div className="pr-inner">
          <div className="pr-heading">
            <div className="pr-tag">Recent Work</div>
            <h2 className="pr-main-title">
              Featured <span className="pr-accent">Projects</span>
            </h2>
          </div>

          <div className="pr-grid">
            {projects.map((project, index) => (
              <div key={index} className="pr-card">
                <div className="pr-card-img-wrapper">
                  <img 
                    src={project.image} 
                    className="pr-card-img" 
                    alt={project.title}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x220/1a1f2e/00f5d4?text=' + project.title;
                    }}
                  />
                  <div className="pr-card-overlay" />
                </div>
                <div className="pr-card-body">
                  <h3 className="pr-card-title">{project.title}</h3>
                  <p className="pr-card-desc">{project.description}</p>
                  
                  <div className="pr-section-title">Tech Stack</div>
                  <div className="pr-tech-stack">
                    {project.tech.map((tech, idx) => (
                      <span key={idx} className="pr-tech-badge">{tech}</span>
                    ))}
                  </div>
                  
                  <div className="pr-section-title">Key Features</div>
                  <ul className="pr-features-list">
                    {project.features.slice(0, 3).map((feature, idx) => (
                      <li key={idx} className="pr-feature-item">{feature}</li>
                    ))}
                  </ul>
                  
                  <div className="pr-card-actions">
                    <a href={project.github} className="pr-btn pr-btn-github" target="_blank" rel="noopener noreferrer">
                      <FaGithub /> Code
                    </a>
                    <a href={project.demo} className="pr-btn pr-btn-demo" target="_blank" rel="noopener noreferrer">
                      <FaExternalLinkAlt /> Live Demo
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;